module.exports = __webpack_public_path__ + "img/ins-arrow.f8b92397.svg";